import { timestamp } from 'drizzle-orm/pg-core';

/**
 * Soft delete: o `delete()` do `Repository` grava a data aqui em vez de apagar a linha, e as
 * leituras ignoram quem tem `deletedAt` preenchido (ver `notDeleted` em
 * `src/api/core/db-utils/soft-delete.ts`). Use com spread nas tabelas de negócio:
 * `pgTable('x', { ..., ...softDelete })`. Tabelas técnicas (sessões, api keys) não usam.
 *
 * Fica fora de `src/db/schema/` de propósito: tudo que é exportado de lá vira schema do Drizzle.
 */
export const softDelete = {
  deletedAt: timestamp('deleted_at'),
};
